import React, { useState } from "react";

export default function PushToDisableButton({ token, onSuccess }) {
  const [loading, setLoading] = useState(false);

  const handlePush = async () => {
    const ask = window.confirm(
      "Proses ini akan memindahkan user ke Disabled List.\nPastikan data sudah benar.\n\nLanjutkan?"
    );
    if (!ask) return;

    try {
      setLoading(true);
      const res = await fetch(
        `https://api.wifikamu.my.id/disabled-list/create`,
        {
          headers: { authorization: token },
        }
      );
      const data = await res.json();

      alert(`✔ ${data.message}\nJumlah dipindahkan: ${data.moved}`);

      // Refresh parent
      onSuccess && onSuccess();
    } catch (err) {
      alert("❌ Proses gagal, coba lagi.\nError: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handlePush}
      disabled={loading}
      className={`px-4 py-2 rounded text-white text-sm font-medium 
        ${
          loading
            ? "bg-gray-400 cursor-not-allowed"
            : "bg-green-600 hover:bg-green-700"
        }`}
    >
      {loading ? "Processing..." : "Push Users to Disable List"}
    </button>
  );
}
